import { render, staticRenderFns } from "./chart-header-mobile.component.vue?vue&type=template&id=5c4906cf"
import script from "./chart-header-mobile.component.vue?vue&type=script&lang=js"
export * from "./chart-header-mobile.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports